import { CircularProgress, CircularProgressProps, styled } from "@mui/material";
import { pxToRem } from "../../../../utils/fontSizeUtility";
import React from "react";

export const CenteredCircularProgress = styled(
  CircularProgress,
  {}
)<CircularProgressProps>(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: pxToRem(-12),
  marginLeft: pxToRem(-12),
})) as React.ComponentType<CircularProgressProps>;
